// extracted by mini-css-extract-plugin
export default {"figure":"CallNumber_figure__Fx4Xb","visible":"CallNumber_visible__JUvq2","img":"CallNumber_img__6oDQC","caption":"CallNumber_caption__7SY65"};